import React from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { useLanguage } from "@/contexts/LanguageContext";
import { useLocalizedPath } from "@/hooks/useLocalizedPath";

const LanguageSwitcher = () => {
  const { language, setLanguage } = useLanguage();
  const navigate = useNavigate();
  const { switchLanguagePath } = useLocalizedPath();

  const toggleLanguage = () => {
    const newLang = language === 'en' ? 'sv' : 'en';
    setLanguage(newLang);
    const newPath = switchLanguagePath(newLang);
    navigate(newPath);
  };

  return (
    <Button 
      variant="outline" 
      size="sm" 
      onClick={toggleLanguage}
      className="text-sm"
    >
      {language === 'en' ? '🇸🇪 Svenska' : '🇬🇧 English'}
    </Button>
  );
};

export default LanguageSwitcher;
